import MicroAnimations from "../../../../content/blog/30-09-2021-micro-animations/MicroAnimations";
import Figure from "../../../../src/components/Figure";
import * as React from 'react';
export default {
  MicroAnimations,
  Figure,
  React
};